<template>
  <div class="study-detail">
    <div class="study-detail-posi" @click="join()">
      <img src="@/assets/studyClass/icon-bm.png" alt />
      <span>报名参加</span>
    </div>
    <classShow :msg="msg" />

    <div class="study-detail-choose">
      <span
        v-for="(data,i) in choose"
        :key="i"
        :class="i==choosed?'choosed':''"
        @click="assignment(i)"
      >{{data}}</span>
    </div>

    <div class="study-detail-class" v-show="choosed==0">
      <div class="study-detail-title">图文学习</div>
      <div
        class="study-detail-class-text-template"
        @click="lookDetail(data.id)"
        v-for="(data,i) in clasS.tuwen"
        :key="i"
      >
        <p class="study-detail-class-text-template-title">{{data.title}}</p>
        <div class="study-detail-class-text-template-progress">
          <p>学习进度：</p>
          <el-progress :percentage="getProgress(data)" :color="[{color:'#f56c6c'}]"></el-progress>
        </div>
        <img :src="data.images | img" :onerror="errors(i)" v-show="errors()" />
      </div>
      <div class="study-detail-title">视频学习</div>
      <div class="study-detail-class-video">
        <div
          class="study-detail-class-video-template"
          @click="lookDetail(data.id)"
          v-for="(data,i) in clasS.shipin"
          :key="i"
        >
          <img :src="data.images | img" :onerror="errors(i)" v-show="errors()" />
          <p class="study-detail-class-video-template-title">{{data.title}}</p>
          <div class="study-detail-class-video-template-progress">
            <p>学习进度：</p>
            <el-progress :percentage="getProgress(data)" :color="[{color:'#f56c6c'}]"></el-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="study-detail-exam" v-show="choosed==1">
      <div class="study-detail-exam-curren">
        <p>{{msg.studyname}}</p>
        <p>
          <span>共计{{test.History.Number }}道题，总分{{test.History.sumfenshu}}，及格分{{test.History.jigefenshu}}</span>
          <span>{{test.History.cishu}}/{{test.History.sumcishu}}考试次数</span>
        </p>
        <button @click="goExam()">开始考试</button>
      </div>
      <div class="study-detail-exam-table">
        <div class="study-detail-title">考试记录</div>
        <el-table :data="test.table" stripe>
          <el-table-column prop="score" label="成绩"></el-table-column>
          <el-table-column prop="starttime" label="考试时间"></el-table-column>
          <el-table-column prop="usetime" label="考试用时"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="study-detail-report" v-show="choosed==2">
      <div class="study-detail-report-template" v-for="(data,i) in report" :key="i">
        <p>{{data.name}}</p>
        <p>{{data.time | times}}</p>
        <p>{{data.title}}</p>
        <img :src="img" v-show="img" />
      </div>
      <div class="study-detail-report-sumbit">
        <button @click="goReport()">撰写我的思想报告</button>
      </div>
    </div>
  </div>
</template>
<script>
import { baseURL } from '@/utils/baseURL.js'

import classShow from "@/views/component/classShow";

export default {
  data() {
    return {
      choose: ["学习课程", "课程测试", "思想汇报"],
      choosed: 0,
      msg: {},
      clasS: {
        shipin: [],
        tuwen: []
      },
      test: {
        table: [],
        History: {}
      },
      report: [],
      img: sessionStorage.getItem("imgheader"),
      percentage: []
    };
  },
  components: {
    classShow
  },
  mounted() {
    let sess = sessionStorage.getItem("/study/detail");
    if (sess != null) this.choosed = sess * 1;
    this.getMsg();
    this.judge();
  },
  methods: {
    getMsg() {
      //
      /* let url = `http://192.168.2.212:16928/api/Index/GetStudyClass?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`; */
      let url = `${baseURL}/api/Index/GetStudyClass?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`;
      this.axios.get(url).then(e => {
        if (e.data.code == 0) {
          this.msg = e.data.msg[0];
          this.msg.Percentage = this.msg.Percentage * 1;
          if (e.data.History) this.percentage = e.data.History;
          // console.log(this.percentage);

          if (e.data.shipin) {
            this.clasS.shipin = e.data.shipin;
          }
          if (e.data.tuwen) {
            this.clasS.tuwen = e.data.tuwen;
          }
        }
      });
    },
    assignment(i) {
      this.choosed = i;
      sessionStorage.setItem("/study/detail", i);

      this.judge();
    },
    getTest() {
      /* let url = `http://192.168.2.212:16928/api/Index/GetScorerecord?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`; */
      let url = `${baseURL}/api/Index/GetScorerecord?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`;
      this.axios.get(url).then(e => {
        if (e.data.code == 0) {
          console.log(e.data);
          if (e.data.History) {
            this.test.History = e.data.History;
          }
          if (e.data.msg) {
            this.test.table = e.data.msg;
          }
        }
      });
    },
    getReport() {
      /* let url = `http://192.168.2.212:16928/api/Index/GetReport?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`; */
      let url = `${baseURL}/api/Index/GetReport?userid=${sessionStorage.getItem(
        "id"
      )}&studyid=${this.$route.query.id}`;
      // console.log(url);

      this.axios.get(url).then(e => {
        if (e.data.code == 0) {
          // // console.log(e.data);
          this.report = e.data.msg;
        }
      });
    },
    goReport() {
      this.$router.push({
        path: "/study/writeReport",
        query: {
          title: "撰写思想报告",
          studyid: this.$route.query.id
        }
      });
    },
    goExam() {
      this.axios
        .get(
          `/api/Index/GetStarttheexam?userid=${sessionStorage.getItem(
            "id"
          )}&studyid=${this.$route.query.id}`
        )
        .then(e => {
          if (e.data.code == 0) {
            this.$router.push({
              path: "/study/exam",
              query: {
                title: "学习班测试",
                studyId: this.$route.query.id
              }
            });
          } else {
            this.$message({
              message: "请报名之后再开始考试！",
              type: "error",
              offset: 300
            });
          }
        });
    },
    errors(i) {
      return false;
    },
    judge() {
      switch (this.choosed) {
        case 0:
          this.getMsg();
          break;
        case 1:
          this.getTest();
          break;
        case 2:
          this.getReport();
          break;
        default:
          break;
      }
    },
    join() {
      this.axios
        .post(`/api/Index/PostEntrystudy`, {
          name: sessionStorage.getItem("name"),
          userid: sessionStorage.getItem("id"),
          studyid: this.$route.query.id,
          studyname: this.msg.studyname
        })
        .then(e => {
          if (e.data.code == 0) {
            this.$message({
              message: "报名成功",
              type: "success",
              offset: "300"
            });
          } else {
            this.$message({
              message: "报名失败，请稍后重试",
              type: "error",
              offset: "300"
            });
          }
        });
    },
    lookDetail(id) {
      this.$router.push({
        path: "/study/haveClass",
        query: {
          title: "课件学习",
          classId: id,
          studyId: this.$route.query.id
        }
      });
    },
    getProgress(data) {
      let progressNum = 0;
      this.percentage.filter(item => {
        if (data.id == item.id) {
          if (!item.Percentage) item.Percentage = 0;
          progressNum = item.Percentage * 1;
        }
      });      
      return progressNum;
    }
  }
};
</script>
<style lang='scss' scoped>
.study-detail {
  &-report {
    &-sumbit {
      button {
        width: 90%;
        height: 0.9rem;
        background: linear-gradient(
          1deg,
          rgba(249, 185, 77, 1),
          rgba(253, 203, 118, 1)
        );
        box-shadow: 0.01rem 0.08rem 0.08rem 0px rgba(0, 0, 0, 0.08);
        border-radius: 0.08rem;
        border: none;
        color: #fff;
        font-size: 0.28rem;
      }
      text-align: center;
      position: fixed;
      bottom: 0.5rem;
      width: 94%;
    }
    &-template {
      p {
        &:nth-child(3) {
          grid-column-start: 2;
          grid-column-end: 11;
          grid-row-start: 2;
          color: #666666;
        }
        &:nth-child(1) {
          grid-column-start: 2;
          grid-column-end: 7;
          grid-row-start: 1;
          grid-row-end: 2;
        }
        &:nth-child(2) {
          grid-column-start: 10;
          grid-column-end: 11;
          grid-row-start: 1;
          grid-row-end: 2;
          font-size: 0.26rem;
          color: #999999;
        }
      }
      img {
        width: 0.74rem;
        height: 0.74rem;
        border-radius: 50%;
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 3;
      }
      background: #fff;
      border-radius: 0.1rem;
      padding: 0.2rem;
      display: grid;
      padding-bottom: 2rem;
    }
    width: 94%;
    margin: 0.2rem auto;
  }
  &-exam {
    &-curren {
      button {
        width: 1.8rem;
        height: 0.58rem;
        background: linear-gradient(
          1deg,
          rgba(249, 185, 77, 1),
          rgba(253, 203, 118, 1)
        );
        border-radius: 0.04rem;
        border: none;
        color: #fff;
        font-size: 0.28rem;
      }
      p {
        &:nth-child(1) {
          line-height: 3;
          border-bottom: 0.01rem solid #e6e6e6;
        }
        &:nth-child(2) {
          span {
            &:nth-child(2) {
              float: right;
              background: #fad9d9;
              padding: 0.05rem;
            }
          }
          color: #fc372d;
          margin: 0.2rem 0;
          color: 0.26rem;
        }
      }
      width: 94%;
      margin: 0.2rem auto;
      padding: 0.2rem;
      background: #fff;
    }
  }
  &-class {
    &-video {
      &-template {
        &-progress {
          color: #999999;
          font-size: 0.26rem;
        }
        &-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          word-break: break-all;
        }
        img {
          width: 100%;
          height: 2.4rem;
        }
        background: #fff;
        padding: 0.2rem;
      }
      display: grid;
      grid-gap: 0.2rem;
      grid-template-columns: 49% 49%;
      padding: 0.2rem;
    }
    &-text {
      &-template {
        &-progress {
          color: #999999;
          font-size: 0.26rem;
          grid-row-start: 2;
          grid-row-end: 3;
        }
        &-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          word-break: break-all;
          grid-row-start: 1;
          grid-row-end: 2;
          min-width: 3.5rem;
        }
        img {
          width: 2.4rem;
          height: 2rem;
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 1;
          grid-row-end: 3;
        }
        display: grid;
        grid-gap: 0.2rem;
        background: #fff;
        padding: 0.2rem;
        width: 94%;
        margin: 0.2rem auto;
      }
    }
  }
  &-title {
    font-weight: bold;
    line-height: 3;
    padding: 0 0.2rem;
  }
  &-choose {
    .choosed {
      &::before {
        position: absolute;
        content: "";
        width: 50%;
        left: 25%;
        bottom: 0;
        height: 0.08rem;
        background: #f9ba50;
        border-radius: 0.08rem;
      }
      color: #f9ba50;
      position: relative;
    }

    span {
      color: #999999;
      text-align: center;
    }
    background: #fff;
    line-height: 3;
    display: flex;
    justify-content: space-around;
  }

  &-posi {
    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.1rem;
    }
    position: fixed;
    right: 0.2rem;
    top: 0.2rem;
    z-index: 11;
    color: #f6ac2e;
    display: flex;
    align-items: center;
  }
  font-size: 0.3rem;
  padding-top: 1.1rem;
}
</style>